import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

import { LprHotlistGroupsAPI, SnLpr } from '../../api';

@Component({
  templateUrl: './add-hotlist-group-dialog.component.html',
  styleUrls: ['./add-hotlist-group-dialog.component.scss'],
})
export class AddHotlistGroupDialogComponent implements OnInit, OnDestroy {
  public form = new UntypedFormGroup({});
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        type: 'text',
        required: true,
      },
    },
    {
      key: 'hotlist',
      defaultValue: this.data.id,
      templateOptions: {
        label: t('common.hotlist'),
      },
    },

  ];

  public formModel: any = {};
  public isLoading: boolean = false;

  private readonly _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnLpr,
    private readonly _dialogRef: MatDialogRef<AddHotlistGroupDialogComponent>,
    private readonly _lprGroupsAPI: LprHotlistGroupsAPI,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this.isLoading = true;
    this.formModel.lprHostlistObjects = [];
    this._lprGroupsAPI
      .create(this.formModel)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (group) => {
          this.isLoading = false;
          this._dialogRef.close(group);
        },
        error: () => {
          this.isLoading = false;
          this._dialogRef.close();
        },
      });
  }
}
